module.exports = __webpack_public_path__ + "media/images/new_landing/articles/learn-1-a34eecb6ead50109a7b3d1cc9e10e2a9.jpeg";